if (!customElements.get('thaani-soft-launch')) {
  customElements.define('thaani-soft-launch', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.key = `thaani-launch-${this.dataset.version || 'runde-1'}`;
      this.tage = Number(this.dataset.tage) || 7;
      this.alteMerkerUebernehmen();
      const sekunden = Number(this.dataset.verzoegerung);
      this.verzoegerung = this.dataset.verzoegerung !== '' && sekunden >= 0 ? sekunden * 1000 : 10000;
      // Nur eine Anmeldung ueber das Popup selbst zeigt es sofort wieder (Danke oder Fehler).
      // Andere Kundenformulare der Seite (Footer, Benachrichtigen) setzen dieselbe Shopify-Meldung.
      this.gesendetKey = `${this.key}-gesendet`;
      this.eigeneAnmeldung = false;
      try {
        const ergebnis = this.querySelector('[data-success], [role="alert"]');
        this.eigeneAnmeldung = sessionStorage.getItem(this.gesendetKey) === '1' && !!ergebnis;
        if (this.eigeneAnmeldung) sessionStorage.removeItem(this.gesendetKey);
      } catch {}
      this.onSubmit = () => { try { sessionStorage.setItem(this.gesendetKey, '1'); } catch {} };
      this.form = this.querySelector('form');
      this.onClose = () => {
        document.documentElement.classList.remove('thaani-launch-open');
      };
      this.onClick = (event) => {
        if (event.target.closest('[data-close]') || event.target === this.dialog) this.dialog.close();
      };
      this.onConsent = () => this.schedule();
      this.dialog.addEventListener('close', this.onClose);
      this.dialog.addEventListener('click', this.onClick);
      if (this.form) this.form.addEventListener('submit', this.onSubmit);
      document.addEventListener('privacybee:ready', this.onConsent);
      document.addEventListener('privacybee:consent-changed', this.onConsent);
      if (this.dataset.editor !== 'true') this.schedule();
    }
    // Frueher hing der Merker am uebersetzbaren Text «Hinweis-Version», je
    // Sprache gab es einen eigenen (thaani-launch-oktober-…, -octobre-…).
    // Die letzte Anzeige daraus zaehlt einmalig fuer die erste Runde, danach
    // sind die alten Merker weg.
    alteMerkerUebernehmen() {
      try {
        const alte = [];
        for (let i = 0; i < localStorage.length; i++) {
          const k = localStorage.key(i);
          if (k && k.startsWith('thaani-launch-') && !k.startsWith('thaani-launch-runde-')) alte.push(k);
        }
        if (!alte.length) return;
        let zuletzt = 0;
        alte.forEach((k) => {
          zuletzt = Math.max(zuletzt, Number(localStorage.getItem(k)) || Date.now());
          localStorage.removeItem(k);
        });
        if (this.key === 'thaani-launch-runde-1' && localStorage.getItem(this.key) === null) {
          localStorage.setItem(this.key, String(zuletzt));
        }
      } catch {}
    }
    schedule() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.open(), this.eigeneAnmeldung ? 300 : this.verzoegerung);
    }
    open() {
      if (!this.isConnected || this.dialog.open || typeof this.dialog.showModal !== 'function') return;
      const submitted = this.eigeneAnmeldung && this.querySelector('[data-success], [role="alert"]');
      // Gemerkt wird der Zeitpunkt der letzten Anzeige; erst nach this.tage
      // Tagen erscheint der Hinweis wieder. Alte Eintraege ('dismissed') zaehlen ab jetzt.
      try {
        const zuletzt = localStorage.getItem(this.key);
        if (zuletzt && !submitted) {
          if (!Number(zuletzt)) { localStorage.setItem(this.key, String(Date.now())); return; }
          const vergangen = Date.now() - Number(zuletzt);
          if (vergangen >= 0 && vergangen < this.tage * 86400000) return;
        }
      } catch {}
      if (this.dataset.consent === 'true') {
        const consent = window.PrivacyBee || window.privacybeeCookieBanner;
        if (!consent || !consent.hasExplicitConsent?.()) return;
      }
      if (document.querySelector('dialog[open], menu-drawer details[open], cart-drawer.active')) return;
      this.dialog.showModal();
      document.documentElement.classList.add('thaani-launch-open');
      try { localStorage.setItem(this.key, String(Date.now())); } catch {}
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.dialog.removeEventListener('close', this.onClose);
      this.dialog.removeEventListener('click', this.onClick);
      if (this.form) this.form.removeEventListener('submit', this.onSubmit);
      document.removeEventListener('privacybee:ready', this.onConsent);
      document.removeEventListener('privacybee:consent-changed', this.onConsent);
      document.documentElement.classList.remove('thaani-launch-open');
    }
  });
}
